import global from "global";

export default () => {
  const {
    performance: {
      timing: { responseStart, navigationStart }
    }
  } = global;

  return responseStart - navigationStart;
};
